import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { setDrawer } from 'slices/drawer'
import { setModal } from 'slices/modal'
import { INTERNAL_REDIRECT_KEYS, INTERNAL_REDIRECT_TYPE } from 'app-constants'

export function useRedirect(origin, onChangeType = () => {}) {
  const dispatch = useDispatch()
  const { push } = useHistory()

  function getInternalRedirect(redirectKey) {
    return INTERNAL_REDIRECT_KEYS.find(({ KEY }) => KEY === redirectKey)
  }

  function handleModalRedirect(key) {
    if (origin !== INTERNAL_REDIRECT_TYPE.MODAL) onChangeType()
    dispatch(setModal({ key }))
  }

  function handleDrawerRedirect(key) {
    if (origin !== INTERNAL_REDIRECT_TYPE.DRAWER) onChangeType()
    dispatch(setDrawer(key))
  }

  function handleRouteRedirect(to) {
    if (origin !== INTERNAL_REDIRECT_TYPE.ROUTE) onChangeType()
    push(to)
  }

  function handleInternalRedirect(redirect) {
    if (!redirect) return

    switch (redirect.TYPE) {
      case INTERNAL_REDIRECT_TYPE.MODAL:
        handleModalRedirect(redirect.TO)
        break
      case INTERNAL_REDIRECT_TYPE.DRAWER:
        handleDrawerRedirect(redirect.TO)
        break
      case INTERNAL_REDIRECT_TYPE.ROUTE:
        handleRouteRedirect(redirect.TO)
        break
      default:
        break
    }
  }

  function isExternalUrl(url) {
    try {
      return !!new URL(url)
    } catch (_) {
      return false
    }
  }

  function handleCtaRedirect(key) {
    const internalRedirect = getInternalRedirect(key)
    handleInternalRedirect(internalRedirect)
  }

  return {
    getInternalRedirect,
    handleInternalRedirect,
    handleCtaRedirect,
    isExternalUrl,
  }
}
